/**
 * 设备的类型的轨计划
 * date：2022 03 24  fuck
 */
export default {
    deviceType: {
        sensor: 'Temp & RH Sensor',
        gateway: 'Gateway',
        display: 'Digital Display',
        relay: 'Repeater',
        zbp_1: 'ZigBee Temperature Sensor',
        zbp_2: 'Zigbee Temp.&RH Sensor',
        lora_1: 'LoRa Temperature Sensor',
        lora_2: 'LoRa Temperature Sensor',
        zeta_1: 'Zeta Temperature Sensor',
        zeta_2: 'Zeta Temperature Sensor',
        gt_1: 'Gateway V1.0',
        gt_2: 'Gateway V1.0 with GPS',
        gt_3: 'Gateway V2.0',
        dt_1: 'Display V1.0',
        rt_1: 'Repeater V1.0'
    }
};
